export const tipoProcessoModel = {
  tipoProcesso: function () {
    return {
      id: "",
      descricao: "",
    }
  },
}


// WEBPACK FOOTER //
// ./src/views/TipoProcesso/_model/index.js